import {Directive, HostBinding, HostListener, Input, OnDestroy} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {copyTextToClipboard} from '../copy-button/clipboard.util';

@Directive({
    selector: '[appVehicleNumberCopy]',
    standalone: true,
})
export class VehicleNumberCopyDirective implements OnDestroy {
    @Input('appVehicleNumberCopy') vehicleNumber: string | null | undefined = '';

    @HostBinding('class.vehicle-number-copy')
    readonly copyClass = true;

    @HostBinding('class.vehicle-number-copy--copied')
    copied = false;

    @HostBinding('attr.title')
    get tooltip(): string {
        return this.copied ? 'Copied' : 'Click to copy vehicle number';
    }

    @HostBinding('attr.role')
    readonly role = 'button';

    @HostBinding('attr.tabindex')
    readonly tabIndex = 0;

    @HostBinding('attr.data-copy-state')
    get copyState(): 'copied' | 'idle' {
        return this.copied ? 'copied' : 'idle';
    }

    private resetTimer: ReturnType<typeof setTimeout> | null = null;
    private copyInProgress = false;

    constructor(private toastr: ToastrService) {
    }

    @HostListener('click', ['$event'])
    onClick(event: Event): void {
        event.stopPropagation();
        this.copyValue();
    }

    @HostListener('keydown.enter', ['$event'])
    @HostListener('keydown.space', ['$event'])
    onKeydown(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        this.copyValue();
    }

    private copyValue(): void {
        const value = (this.vehicleNumber || '').trim();
        if (!value || value === '-' || this.copyInProgress) {
            return;
        }

        this.copyInProgress = true;
        void copyTextToClipboard(value).then((success) => {
            this.copyInProgress = false;
            if (!success) {
                this.toastr.error('Unable to copy vehicle number.', 'Copy failed');
                return;
            }
            this.copied = true;
            if (this.resetTimer) {
                clearTimeout(this.resetTimer);
            }
            this.resetTimer = setTimeout(() => {
                this.copied = false;
                this.resetTimer = null;
            }, 2000);
        });
    }

    ngOnDestroy(): void {
        if (this.resetTimer) {
            clearTimeout(this.resetTimer);
        }
    }
}
